import React, { useLayoutEffect, useRef, useState } from "react";

// Renders a diagram at its desktop layout (designWidth) and, on narrower
// screens, scales it down like a picture instead of re-flowing it, so the
// connectors and structure keep their meaning on phones.
const ScaledDiagram = ({ designWidth, children }) => {
  const outer = useRef(null);
  const inner = useRef(null);
  const [scale, setScale] = useState(1);
  const [height, setHeight] = useState("auto");

  useLayoutEffect(() => {
    const update = () => {
      if (!outer.current || !inner.current) return;
      const available = outer.current.clientWidth;
      const next = Math.min(1, available / designWidth);
      setScale(next);
      setHeight(next < 1 ? inner.current.scrollHeight * next : "auto");
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(outer.current);
    ro.observe(inner.current);
    return () => ro.disconnect();
  }, [designWidth]);

  const scaled = scale < 1;
  return (
    <div ref={outer} style={{ width: "100%", height, overflow: "hidden" }}>
      <div
        ref={inner}
        style={
          scaled
            ? {
                width: designWidth,
                // room for the boxes' shadows, which overflow: hidden would clip
                paddingBottom: 24,
                transform: `scale(${scale})`,
                transformOrigin: "top left",
              }
            : undefined
        }
      >
        {children}
      </div>
    </div>
  );
};

export default ScaledDiagram;
